import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import SimpleModalWrapped from "../../common/Modal";
import TextField from "../../common/TextField";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});

class AddMakeModal extends Component {
  render() {
    return (
      <SimpleModalWrapped
        {...this.props}
        visable
        isButtonVisable
        title={this.props.title}
        formSubmit={this.props.formSubmit}
        modalControle={this.props.modalControle}
        btnclosetext={this.props.translate("sharedBack")}
        buttonText={this.props.buttonText}
        isVisableBtn={this.props.isVisableCreateBtn}
        content={
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="makeName"
                label={this.props.translate("makeName")}
                type="text"
                placeholder=""
                value={this.props.form?.makeName || ""}
                onChange={this.props.handleChange("makeName")}
                variant="outlined"
                margin="dense"
                fullWidth
                required
              />
            </Grid>
          </Grid>
        }
      />
    );
  }
}

export default withStyles(styles)(AddMakeModal);
